import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const SignUp = () => {
  const [form, setForm] = useState({ name: '', mobile: '', email: '', pincode: '' });
  const navigate = useNavigate();

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    // Simulate signup success and login
    localStorage.setItem('isLoggedIn', 'true');
    navigate('/home');
  };

  return (
    <div className="login-bg">
      <div className="login-center-card">
        <div className="login-logo">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#0090d0"/><path d="M24 14v20M14 24h20" stroke="#fff" strokeWidth="3" strokeLinecap="round"/></svg>
        </div>
        <h2 className="login-title">Sign Up</h2>
        <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
          <input name="name" type="text" placeholder="Full Name" value={form.name} onChange={handleChange} required className="login-input" />
          <input name="mobile" type="text" placeholder="Mobile Number" value={form.mobile} onChange={handleChange} required className="login-input" />
          <input name="email" type="email" placeholder="Email Address" value={form.email} onChange={handleChange} required className="login-input" />
          <input name="pincode" type="text" placeholder="Pincode" value={form.pincode} onChange={handleChange} required className="login-input" />
          <button type="submit" className="login-btn">Next</button>
        </form>
      </div>
    </div>
  );
};

export default SignUp; 